import React, { useCallback, useEffect, useState } from "react";
import useInput from "../../../hooks/useInput";
import { useAppDispatch } from "../../../store";
import { Navigate, useNavigate, createSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer/index";
import * as styles from "../../../styles/AdvicePage";
import userSlice from "../../../reducer/user";
import { API_BASE_URL, LoadCounsel } from "../../../reduxaction/post";
import { useInView } from "react-intersection-observer";

import dayjs from "dayjs";
import "dayjs/locale/ko";
import postSlice from "../../../reducer/post";

dayjs.locale("ko");

const AdvicePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState<number>(1);
  const { CounselListList, LoadCounselListLoading } = useSelector(
    (state: RootState) => state.post
  );

  const { me } = useSelector((state: RootState) => state.user);
  useEffect(() => {
    dispatch(userSlice.actions.Routerpath("/AdvicePage"));
  }, []);

  useEffect(() => {
    dispatch(postSlice.actions.refreshCounselListList());

    dispatch(LoadCounsel(`page=${0}&size=10`));
  }, [dispatch]);

  // ------------- 인피니트 스크롤링 코드

  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0.1,
  });

  useEffect(() => {
    // 사용자가 마지막 요소를 보고 있고, 로딩 중이 아니라면 page+=1

    if (inView && !LoadCounselListLoading) {
      console.log("제일끝!!!");
      setPage(page + 1);
      dispatch(LoadCounsel(`page=${page}&size=10`));
    }
  }, [inView, page]);

  return (
    <styles.Container>
      <styles.PageTop>
        <p className="pagetit">상담</p>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
              navigate("/MainPage");
            }}
            alt="X"
          />
        </p>
      </styles.PageTop>

      {CounselListList.length >= 1 ? (
        CounselListList.map((councels) => {
          const expertcomment = councels.comment.filter(
            (comment) => comment.writerId === "won1"
          );

          let answer: any = [];

          councels.comment.forEach((counsel: any) => {
            counsel.childComment.forEach((child: any) => {
              if (child.writerId === "won1") answer.push(child);
            });
          });

          const experts = expertcomment.length + answer.length;

          const Createday = dayjs(councels.regDate).format(
            "YYYY년 MM월 DD일 dddd HH시 mm분"
          );

          const gotoAdviceDetail = () => {
            navigate({
              pathname: "/AdviceDetail",
              search: createSearchParams({
                counselId: councels.counselId.toString(),
              }).toString(),
            });
          };

          return (
            <styles.AdviceList ref={ref} key={councels.counselId}>
              <styles.AdviceListItem onClick={gotoAdviceDetail}>
                <div className="advice-top">
                  <p className="advice-name">{councels.member.name}</p>
                  <p className="advice-date">{Createday}</p>
                </div>
                <p className="advice-content">{councels.title}</p>
                <div className="advice-img">
                  {councels.file.map((image) => {
                    return (
                      <p
                        className="advice-img-item"
                        style={{ marginRight: 150 }}
                      >
                        <img
                          style={{
                            height: "200px",
                            width: "200px",
                            objectFit: "cover",
                          }}
                          // src={`http://192.168.10.55:23500/ifactroy/api/file/downloadfile/${image.name}`}
                          src={`${API_BASE_URL}/ifactroy/api/file/downloadfile/${image.name}`}
                        />
                      </p>
                    );
                  })}
                </div>
                <div className="advice-comment">
                  <div className="advice-comment-info">
                    <p className="advice-comment-user"></p>
                  </div>
                  <p
                    className="advice-comment-text"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img
                      src="./img/AdviceWrite.svg"
                      style={{ marginRight: 10 }}
                    />
                    {experts >= 1 ? (
                      <>곤충전문가가 댓글을 남겼습니다.</>
                    ) : (
                      <>곤충전문가의 댓글이 없습니다.</>
                    )}
                    <span></span>
                  </p>
                </div>
              </styles.AdviceListItem>
            </styles.AdviceList>
          );
        })
      ) : (
        <styles.AdviceList ref={ref}>
          <div className="wrapper">
            <div>
              문의사항에 관해 전문가가 직접 답변 해줍니다.
              <span className="spnas">
                <img src="./img/AdviceWrite.svg" />{" "}
                <span>버튼을 눌러 작성해주세요</span>
              </span>
            </div>
          </div>
        </styles.AdviceList>
      )}

      <styles.AdviceWriteBtn
        onClick={() => {
          navigate("/Advicewrite");
        }}
      >
        <p>
          <img src="./img/AdviceWrite.svg" />
        </p>
        <p>작성</p>
      </styles.AdviceWriteBtn>
    </styles.Container>
  );
};

export default AdvicePage;
